<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.spfr" alt>
      </p>
      <p>
        <br>
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:宋体;">Level Rewinding Machine</span>
          </u>
        </b>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:Arial;"></span>
          </u>
        </b>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">&nbsp;</span>
      </p>
      <p>
        <span
          style="font-family:宋体;font-size:12pt;text-indent:42pt;line-height:1.5;"
        >This unit is used for scattered refined copper tube after spinning, through the process such as straighten, clean, dry, detect (print), pre-flex, split without crumbs, and roll them densely and orderly into a cable shape plate, as the finished product delivery or further annealing. This unit had been sold to Ukraine etc. </span>
      </p>
      <p>
        <span>&nbsp;</span>
      </p>
      <div align="center">
        <table
          style="width:418.5pt;"
          class="ke-zeroborder"
          border="0"
          cellpadding="0"
          cellspacing="0"
          width="558"
        >
          <tbody>
            <tr>
              <td>
                <div align="center">
                  <table
                    style="width:90.0%;"
                    class="ke-zeroborder"
                    border="0"
                    cellpadding="0"
                    cellspacing="0"
                    width="90%"
                  >
                    <tbody>
                      <tr>
                        <td style="background:#F4F4F4;">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:11.5pt;line-height:150%;font-family:宋体;color:#000099;"
                            >Technical parameters</span>
                            <span
                              style="font-size:11.5pt;line-height:150%;font-family:Arial;color:#000099;"
                            ></span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div align="center">
                            <table
                              style="background:black;"
                              class="ke-zeroborder"
                              border="0"
                              cellpadding="0"
                              cellspacing="1"
                            >
                              <tbody>
                                <tr>
                                  <td style="background:white;" width="43">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >No.</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:left;" align="left">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >Model</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >
                                        <br>
                                      </span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >Data</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      ></span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="72">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >Unit</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      ></span>
                                    </p>
                                  </td>
                                  <td colspan="2" style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >Range</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      ></span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      ></span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      ></span>
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="background:white;" width="43">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >1</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >O.D.of tube</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      ></span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="72">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >mm</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >Φ4-19</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="78">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >Φ1.5-8</span>
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="background:white;" width="43">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >2</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >Max. wall thickness</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      ></span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="72">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >mm</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >1.2</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="78">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >1.0</span>
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="background:white;" width="43">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >3</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >Max. coil weight</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      ></span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="72">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >Kg</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >300</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="78">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >150</span>
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="background:white;" width="43">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >4</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >Coiling speed</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      ></span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="72">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >m/min</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >0-300
                                        <br>0-500
                                      </span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="78">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >0-120</span>
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="background:white;" width="43">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >5</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >Max. O.D.of coil</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      ></span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="72">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >mm</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >Φ1230</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="78">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >Φ700</span>
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="background:white;" width="43">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >6</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >Coil width</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      ></span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="72">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >mm</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >120-400</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="78">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >50-200</span>
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="background:white;" width="43">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >7</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >I.D.of coil</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      ></span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="72">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >mm</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >Φ610</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="78">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >Φ300</span>
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="background:white;" width="43">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >8</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >Total installed power</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      ></span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="72">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >kw</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >75</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >，</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >90</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="78">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >22</span>
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="background:white;" width="43">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >9</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >Pressure of hydraulic system</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      ></span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="72">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >Kg/cm2</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >63</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="78">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >40</span>
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="background:white;" width="43">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >10</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >Flow quantity of hydraulic system</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      ></span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="72">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >L/min</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >34</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="78">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >24</span>
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="background:white;" width="43">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >11</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >Pressure of compressed air</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      ></span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="72">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >Kg/cm2</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >4-7</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="78">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >4</span>
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="background:white;" width="43">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >12</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >Total length of machine</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      ></span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="72">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >m</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >11.5</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="78">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >7.7</span>
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="background:white;" width="43">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >13</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                                      >Height of machine center line</span>
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      ></span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="72">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >m</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="156">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >1.5</span>
                                    </p>
                                  </td>
                                  <td style="background:white;" width="78">
                                    <p style="text-align:center;" align="center">
                                      <span
                                        style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                                      >1.2</span>
                                    </p>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#000099;"
                            ></span>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <p style="text-align:center;" align="center">
                  <span style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"></span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <br>
        </span>
      </p>
      <p>
        <br>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        spfr: require("../../../assets/img/common/spfr.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/ew/device/spfr.vue